import { EnvConfig } from './types/env.types'

export const env: EnvConfig = {
  baseUrl: 'https://api.beattractive.fr/',
  sentryDsn: 'https://c601aea1ba6144008e1e3885898f7755@o1300890.ingest.sentry.io/6549943',
  clientUuid: 'eed42d72-ca15-4e83-a49c-94d3da916df6',
  ENV: 'laCiotat',
  featureFlags: {
    areCheatCodesEnabled: false,
    isCodePushEnabled: false,
    isCodePushManual: false,
    isFavoritesEnabled: false,
  },
  matomoUrlBase: 'https://analytics.tools.citopia.fr/',
  matomoSiteId: 17,
  baseSurveyUrl: 'https://sondage.prod.tools.citopia.fr/survey',
}
